import {HStack} from '@chakra-ui/react';
import {FC, PropsWithChildren} from 'react';

import {LanguageSelector} from '../header/components';
import {Profile} from '../profile';

interface IProps {
  isDesktop: boolean;
  accordionMobileSize?: string;
}

export const RightBlock: FC<PropsWithChildren<IProps>> = ({children, isDesktop}) => {
  return (
    <HStack alignItems="center" spacing="30px">
      {children}
      <LanguageSelector isDesktop={isDesktop} />
      <Profile />
    </HStack>
  );
};
